import BootstrapField from '../utility/BootstrapField';
import moment from 'moment-timezone';
// import CloneDeep from 'lodash.clonedeep';
import LaneClosureBlockLane from '../models/LaneClosureBlockLane';
import LaneClosureBlockRestriction from '../models/LaneClosureBlockRestriction';
import LaneClosureBlockSidewalk from '../models/LaneClosureBlockSidewalk';
import LaneClosureBlockBicycle from '../models/LaneClosureBlockBicycle';
import Format from '../utility/Format';


// As private as it gets.
// let originalLaneClosureBlockData = null;

export default class LaneClosureBlock {
	constructor(data) {
		if (!data) {
			data = {};
		}
		if (data.useTestData) {
			data = {}

		}

		Object.assign(this, {
			blockId: data.blockId || null,
			directionId: data.directionId || null,
			streetName: new BootstrapField({
				value: data.streetName || null,
				required: true,
			}),
			fromStreet: new BootstrapField({
				value: data.fromStreet || null,
				required: true,
			}),
			toStreet: new BootstrapField({
				value: data.toStreet || null,
				required: true,
			}),
			kml: data.kml || null,
			lanesClosedSameTime: new BootstrapField({
				value: data.lanesClosedSameTime || null,
				required: true,
			}),
			trafficSignalsAltered: new BootstrapField({
				value: typeof data.trafficSignalsAltered === 'number' ? data.trafficSignalsAltered : null,
			}),

			northboundLeft: data.northboundLeft || null,
			northboundRight: data.northboundRight || null,
			northboundThrough: data.northboundThrough || null,

			southboundLeft: data.southboundLeft || null,
			southboundRight: data.southboundRight || null,
			southboundThrough: data.southboundThrough || null,

			eastboundLeft: data.eastboundLeft || null,
			eastboundRight: data.eastboundRight || null,
			eastboundThrough: data.eastboundThrough || null,

			westboundLeft: data.westboundLeft || null,
			westboundRight: data.westboundRight || null,
			westboundThrough: data.westboundThrough || null,


			northboundLeftBacklane: data.northboundLeftBacklane || null,
			southboundLeftBacklane: data.southboundLeftBacklane || null,
			eastboundLeftBacklane: data.eastboundLeftBacklane || null,
			westboundLeftBacklane: data.westboundLeftBacklane || null,

			northboundRightBacklane: data.northboundRightBacklane || null,
			southboundRightBacklane: data.southboundRightBacklane || null,
			eastboundRightBacklane: data.eastboundRightBacklane || null,
			westboundRightBacklane: data.westboundRightBacklane || null,


			northboundLat: data.northboundLat || null,
			northboundLon: data.northboundLon || null,
			southboundLat: data.southboundLat || null,
			southboundLon: data.southboundLon || null,
			eastboundLat: data.eastboundLat || null,
			eastboundLon: data.eastboundLon || null,
			westboundLat: data.westboundLat || null,
			westboundLon: data.westboundLon || null,


			mapPolyline: null,

			bicycle: [],
			sidewalk: [],
			// each lane entry contains: lane_id, lane_name, peakId, peakReason
			lane: [],

			// list of LCR restrictions
			// each restriction contains:  direction, type of restriction, cross street name, restrictionPeakId, peakReason
			restriction: [],
			isEdited: false,
			isDeleted: false,
		});


		if (data.lane instanceof Array) {
			let x = 0;
			for (x = 0; x < data.lane.length; x++) {
				this.lane.push(new LaneClosureBlockLane(data.lane[x]));
			}
		}


		if (data.sidewalk instanceof Array) {
			let x = 0;
			for (x = 0; x < data.sidewalk.length; x++) {
				this.sidewalk.push(new LaneClosureBlockSidewalk(data.sidewalk[x]));
			}
		}

		if (data.bicycle instanceof Array) {
			let x = 0;
			for (x = 0; x < data.bicycle.length; x++) {
				this.bicycle.push(new LaneClosureBlockBicycle(data.bicycle[x]));
			}
		}

		if (data.restriction instanceof Array) {
			let x = 0;
			for (x = 0; x < data.restriction.length; x++) {
				this.restriction.push(new LaneClosureBlockRestriction(data.restriction[x]));
			}
		}


		// Keep a record of the old data. (used for the hasChanges() method)
		// originalLaneClosureBlockData = CloneDeep(this);
	}

	validate() {

		this.toTime.invalidMessage = 'Please enter a valid end time';
		this.toDate.invalidMessage = 'Please enter a valid estimated completion date';
		let flag = true;

		let errors = [];


		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}

		// Check if the end time is earlier than start time
		if (this.toDate.validate() == null && this.fromDate.validate() == null && this.toTime.validate() == null && this.fromTime.validate() == null) {
			if (Format.fromUtc(this.fromDate.value).isSame(Format.fromUtc(this.toDate.value), 'day')) {
				// let startTime = this.fromTime.value;
				// let endTime = this.toTime.value;

				// let start = new Date();
				// start.setHours(startTime.a == 'pm' ? startTime.h + 12 : startTime.h);
				// start.setMinutes(startTime.mm);
				// start.setSeconds(0);

				// let end = new Date();
				// end.setHours(endTime.a == 'pm' ? endTime.h + 12 : endTime.h);
				// end.setMinutes(endTime.mm);
				// end.setSeconds(0);

				// if (start.getTime() >= end.getTime()) {
				//     this.toTime.invalidMessage = 'Estimated completion time cannot be earlier than requested start time';
				//     this.toTime.status = false;
				// }

				let startTime = moment(this.fromTime.getValue(), 'h:mm a');
				let endTime = moment(this.toTime.getValue(), 'h:mm a');

				if (startTime.isSameOrAfter(endTime)) {
					this.toTime.invalidMessage = 'Estimated completion time cannot be earlier than requested start time';
					this.toTime.status = false;
					flag = false;
				}


			}
			// Check if end date is earlier than start date
			else if (Format.fromUtc(this.fromDate.value).isAfter(Format.fromUtc(this.toDate.value), 'day')) {
				this.toDate.invalidMessage = 'Estimated completion date cannot be earlier than requested start date';
				this.toDate.status = false;
				flag = false;
			}

		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getRawValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {
		// var differences = DeepDiff.diff(originalLaneClosureBlockData.getRawValue(),  this.getRawValue());
		// return !IsEqual(originalLaneClosureBlockData.getRawValue(), this.getRawValue());
		return false;
	}
	revertChanges() {
		// this.constructor(originalLaneClosureBlockData);
	}
	saveChanges() {
		// originalLaneClosureBlockData = CloneDeep(this);
	}
}